import React from 'react';
import { Link } from 'react-router-dom';
import WhyChooseImg1 from '../../assets/images/resources/why-choose-one-img-1.jpg';

const WhyChoose = () => {
    return (
        <>
            <section className="why-choose-one">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                            <div className="why-choose-one__left">
                                <div className="section-title text-left">
                                    <div className="section-title__tagline-box">
                                        <span className="section-title__tagline">
                                            Why Choose Sunrising Cinevision
                                        </span>
                                    </div>
                                    <h2 className="section-title__title">
                                        Learn, Create & Produce with Industry Experts
                                    </h2>
                                </div>

                                <p className="why-choose-one__text">
                                    Sunrising Cinevision is a complete creative hub offering both professional training and high-quality production services. From Acting, Direction, Cinematography, and Editing to Film Production, Podcast Studio, Chroma Shoots, and Event Coverage — we provide real industry exposure with hands-on experience.
                                </p>

                                <p className="why-choose-one__text">
                                    Whether you want to learn or create, our expert team, modern studios, and live projects help you grow in the entertainment and media industry.
                                </p>

                                <div className="why-choose-one__btn-box">
                                    <Link to="/about" className="thm-btn why-choose-one__btn">
                                        Explore More
                                        <span />
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-6">
                            <div className="why-choose-one__right">
                                <div className="why-choose-one__img wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
                                    <img src={WhyChooseImg1} alt="Why Choose Us" />

                                    <div className="why-choose-one__delivery-box">
                                        <div className="icon">
                                            <span className="icon-film" />
                                        </div>
                                        <p>
                                            CRASH & WEEKEND
                                            <br /> COURSES
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default WhyChoose;